import React from 'react';

const FORM_INVALID_STATE = 1;

class TeilnahmebedingungenBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    
    // Scope der Componente muss zu Verfügung stehen ... muss für jede Methode gemacht werden!
      this.handleTeilnahmeBedingungenAkzeptiertChange = this.handleTeilnahmeBedingungenAkzeptiertChange.bind(this); 

  }
  // Handler des Farbe
  handleTeilnahmeBedingungenAkzeptiertChange(event) {
    const target = event.target;
    const value = target.checked ? 1 : 0;
    console.log(target.checked );
    this.setState({ teilnahmeBedingungenAkzeptiert: value });
    this.props.onTeilnahmeBedingungenAkzeptiertChange(value);
  }
  
    render() {
      let teilnahmeBedingungenAkzeptiertValid =  ((this.props.teilnahmeBedingungenAkzeptiertIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
      
      return (
      
        <div className="Component Teilnahmebedingungen">
         <section className="flex2">
          <div className="sosumi center">
              <div className="checkboxelement">
              <input
                
                  name="teilnahmeBedingungenAkzeptiert"
                  type="checkbox"
                  value="1"onChange={this.handleTeilnahmeBedingungenAkzeptiertChange} />
                <label className="check-box"></label>
                <p>
                  Ich bestätige, dass ich die <a href="https://www.odernichtoderdoch.de/nutzungsbedingungen-fuer-die-heldenkueche">Teilnehmerbedingungen </a>gelesen habe und sie akzeptiere.</p>
                  <label className={teilnahmeBedingungenAkzeptiertValid}><span className="field-message">Bitte auswählen</span></label>
              </div>
            </div>
          </section>
        </div>
           
      );
    }
  }
export default TeilnahmebedingungenBlock;


// WEBPACK FOOTER //
// ./src/TeilnahmebedingungenBlock.js